import { render } from "./insureTable.vue?vue&type=template&id=559ccef2"
import script from "./insureTable.vue?vue&type=script&lang=js"
export * from "./insureTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__